import type { AudioProps } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { CheckboxField, ColorField, NumberField, TextField } from "./fields.js";
import { MediaField } from "./MediaField.js";
import type { WidgetInspectorProps } from "./registry.js";

export function AudioInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as AudioProps;

  return (
    <>
      <MediaField
        label="Source URL (MP3/OGG/WAV)"
        value={p.src}
        accept="audio/*"
        onChange={(v) => update(widget.id, { src: v })}
      />
      <TextField
        label="Title"
        value={p.title ?? ""}
        onChange={(v) => update(widget.id, { title: v || undefined })}
      />
      <TextField
        label="Artist / author"
        value={p.artist ?? ""}
        onChange={(v) => update(widget.id, { artist: v || undefined })}
      />
      <CheckboxField
        label="Autoplay"
        value={p.autoplay ?? false}
        onChange={(v) => update(widget.id, { autoplay: v })}
      />
      <CheckboxField
        label="Loop"
        value={p.loop ?? false}
        onChange={(v) => update(widget.id, { loop: v })}
      />
      <ColorField
        label="Background"
        value={p.background ?? "#f8fafc"}
        onChange={(v) => update(widget.id, { background: v })}
      />
      <ColorField
        label="Text"
        value={p.textColor ?? "#0f172a"}
        onChange={(v) => update(widget.id, { textColor: v })}
      />
      <NumberField
        label="Radius (px)"
        value={p.radius ?? 12}
        min={0}
        max={32}
        onChange={(v) => update(widget.id, { radius: v })}
      />
    </>
  );
}
